import React, { Fragment, useContext, useRef, useState } from 'react'

import { UserContext } from "../Contexts/UserContext/UserContext.js";
import { Slide } from "../display_wallet.js"
import { Row } from "../components/Row";
import { Spaces } from "../components/Spaces";
import { TextDisplay } from "../components/TextDisplay/TextDisplay";

import { default_func_jsx_fail, mult_to_percent, percent_to_mult } from "../helpers/helpers.js"
import { forceFloat } from "../helpers/helpers.js"
import { Alert } from 'react-bootstrap';
import RowWithTitle from '../components/RowWithTitle.js';
import useLog from '../hooks/useLog.js';
import useTxSender from '../hooks/useTxSender.js';
import SuccessTxSender from '../components/SuccessTxSender';
import { confirmPopupHard } from '../components/confirmPopup.js';
import Bold from '../components/Bold.js';



export default function Slide_PublishMultiplicator(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_PublishMultiplicator: ")

	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_mintuple" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à burn va s'afficher ici"

	// state & refs
	const [val_percent, set_val_percent] = useState("")
	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(val_percent && !Number.isNaN(val_percent)),
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)


	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_val_percent("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	var val_newMult = 1.00
	// we add each field one by one
	if (val_percent && !Number.isNaN(val_percent)) {
		val_newMult = parseFloat(percent_to_mult(val_percent)) // force "1.00" and similar
		jsx_recap =
			<Fragment>
				Nouvelle inflation: {val_percent} %<br />
				(mintuple {val_newMult})
				{val_newMult < 1 ?
					<Fragment><br /><br />
						ATTENTION: ETES VOUS CERTAIN DE VOULOIR UNE INFLATION NÉGATIVE ? <br />
					</Fragment>
					: null}
				<br />
			</Fragment>
	}

	const jsx_sending =
		<Fragment>
			Publication en cours...&nbsp;
			<i className="reloadIcon fas fa-sync fa-spin" />
		</Fragment>


	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Publication du mintuple {txstate.mintuple} avec succès !
				(correspondant à {mult_to_percent(txstate.mintuple)}%)
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- FUNCTIONS ---

	const handleChangeVal = (event) => {
		if (bool_broadcast_lock) return // don't allow edit during sending
		func_resetMess()

		var new_val_percent = event.target.value
		new_val_percent = new_val_percent.toString().replace(/[^0-9.,]/g, ""); // remove unwanted chars, excluding '-'
		new_val_percent = forceFloat(new_val_percent, 8) // force float 

		set_val_percent(new_val_percent)
	}

	const handleClick = async (event) => {
		event.preventDefault() // prevent redirection
		if (bool_broadcast_lock) return

		const confirm_message = "Publier inflation de " + val_percent + "% ?"
		var confirmed = await confirmPopupHard(confirm_message)
		if (!confirmed) return // abort

		log("publishing mintuple val_newMult=", val_newMult, " from val_percent=", val_percent)

		// async but we don't want to await here !
		userContext.publish_mult(val_newMult)
	}

	// --- DISPLAY ---

	log("\n val_percent = ", val_percent,
		"\n bool_broadcast_lock=", bool_broadcast_lock,)	

	return (
		<Slide num={props.num}>
			<h1><i className="fas fa-cubes" /><Spaces count="3" />
				Publier Mintuple</h1>
			<br />
			{userContext.ownerIsAdmin ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<RowWithTitle title={<Fragment>
				Valeur de la nouvelle inflation (en pourcentage)
			</Fragment>}>
				<input style={{ marginBottom: "0px" }} type='number' value={val_percent}
					onChange={handleChangeVal} id='publishmult_multval'
					placeholder="2.35%" className='item' />
			</RowWithTitle>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClick}
					id='publishmult_button' className="submitbutton" >
					Nouvelle inflation&nbsp;
					{val_percent ?
						"de " + (val_percent > 0 ? "+" : "") + val_percent + "%"
						: null}
				</button>
			</Row>
		</Slide>
	)
}
